export const cities = [
  {
    id: 'bogota',
    name: 'Bogotá',
  },
  {
    id: 'medellin',
    name: 'Medellín',
  },
  {
    id: 'cali',
    name: 'Cali',
  },
  {
    id: 'barranquilla',
    name: 'Barranquilla',
  },
  {
    id: 'cartagena',
    name: 'Cartagena',
  },
  {
    id: 'cucuta',
    name: 'Cúcuta',
  },
  {
    id: 'bucaramanga',
    name: 'Bucaramanga',
  },
  {
    id: 'soledad',
    name: 'Soledad',
  },
  {
    id: 'pereira',
    name: 'Pereira',
  },
  {
    id: 'ibague',
    name: 'Ibagué',
  },
  {
    id: 'santa-marta',
    name: 'Santa Marta',
  },
  {
    id: 'villavicencio',
    name: 'Villavicencio',
  },
  {
    id: 'valledupar',
    name: 'Valledupar',
  },
  {
    id: 'manizales',
    name: 'Manizales',
  },
  {
    id: 'monteria',
    name: 'Montería',
  },
  {
    id: 'bello',
    name: 'Bello',
  },
  {
    id: 'pasto',
    name: 'Pasto',
  },
  {
    id: 'neiva',
    name: 'Neiva',
  },
  {
    id: 'envigado',
    name: 'Envigado',
  },
  {
    id: 'tunja',
    name: 'Tunja',
  },
  {
    id: 'popayan',
    name: 'Popayán',
  },
  {
    id: 'floridablanca',
    name: 'Floridablanca',
  },
  {
    id: 'armenia',
    name: 'Armenia',
  },
  {
    id: 'sincelejo',
    name: 'Sincelejo',
  },
  {
    id: 'itagui',
    name: 'Itagüí',
  },
  {
    id: 'valle-del-cauca',
    name: 'Valle del Cauca',
  },
  {
    id: 'sabaneta',
    name: 'Sabaneta',
  },
  {
    id: 'dosquebradas',
    name: 'Dosquebradas',
  },
  {
    id: 'magdalena',
    name: 'Magdalena',
  },
  {
    id: 'other',
    name: 'Other',
  },
]

export default cities
